import { ADVANCED_TARGETING_QUALIFICATION_CODE_MIN } from '../constants/survey-qualification.constants';
import {
  Qualification,
  RangeQualificationDatum,
  SelectableQualificationDatum,
} from '../models';

export const getQualificationName = (qualification: Qualification): string => {
  return qualification.qualificationName;
};

// Mirrors the numeric-code convention Advanced Targeting hydration uses to tell
// a targeting qualification apart from a core/location one (see
// ADVANCED_TARGETING_QUALIFICATION_CODE_MIN's own doc comment).
export const isAdvancedTargetingQualification = (
  qualification: Qualification,
): boolean =>
  qualification.qualificationCode >= ADVANCED_TARGETING_QUALIFICATION_CODE_MIN;

export const getQualificationOptions = (
  qualification: Qualification,
): SelectableQualificationDatum[] => {
  return (qualification.data as SelectableQualificationDatum[]) || [];
};

export const hasCensusData = (qualification: Qualification): boolean => {
  return qualification.census.enabled && !!qualification.census.data?.length;
};

export const getQualificationRange = (
  qualification: Qualification,
): RangeQualificationDatum => {
  return (qualification.data as RangeQualificationDatum[])[0];
};
